import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import GNB from './components/GNB';
import RetirementSettlement from './components/RetirementSettlement';
import ExtrasHub from './components/ExtrasHub';
import HealthInsuranceSettlement from './components/HealthInsuranceSettlement';
import Notice from './components/Notice';
import Experiments from './components/Experiments';
import Payroll from './components/payroll/Payroll';
import MemoWindow from './components/payroll/MemoWindow';
import CompanyInsights from './components/insights/CompanyInsights';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoadingSpinner from './components/common/LoadingSpinner';
import './App.css';

function TokenErrorBanner() {
  const { tokenError, retryTokenValidation, logout } = useAuth();

  if (!tokenError) return null;

  return (
    <div className="token-error-banner">
      <div className="token-error-content">
        <span className="token-error-message">{tokenError}</span>
        <div className="token-error-actions">
          <button onClick={retryTokenValidation} className="btn btn-primary btn-sm">
            재시도
          </button>
          <button onClick={logout} className="btn btn-secondary btn-sm">
            로그아웃
          </button>
        </div>
      </div>
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  
  // URL 경로에서 현재 뷰 결정
  const getCurrentView = () => {
    const path = location.pathname;
    if (path === '/retirement') return 'retirement';
    if (path === '/extras') return 'extras';
    if (path === '/health-insurance') return 'extras'; // 추가 기능 하위 화면
    if (path === '/notice') return 'notice';
    if (path === '/profile') return 'profile';
    if (path === '/admin') return 'admin';
    if (path === '/payroll') return 'payroll';
    if (path === '/insights') return 'insights';
    if (path === '/experiments') return 'experiments';
    return 'notice'; // 기본값: 공지사항
  };
  
  const currentView = getCurrentView();
  
  return (
    <>
      <GNB currentView={currentView} />
      <Routes>
        <Route path="/notice" element={<Notice />} />
        <Route path="/payroll" element={<Payroll />} />
        <Route path="/insights" element={<CompanyInsights />} />
        <Route path="/employees" element={<Navigate to={`/insights${location.search}`} replace />} />
        <Route path="/payroll-plus" element={<Navigate to={`/payroll${location.search}`} replace />} />
        <Route path="/retirement" element={<RetirementSettlement />} />
        <Route path="/extras" element={<ExtrasHub />} />
        <Route path="/health-insurance" element={<HealthInsuranceSettlement />} />
        <Route path="/profile" element={<Home currentView="profile" />} />
        <Route path="/admin" element={<Home currentView="admin" />} />
        <Route path="/experiments" element={<Experiments />} />
        <Route path="/" element={<Navigate to="/notice" replace />} />
        <Route path="*" element={<Navigate to="/notice" replace />} />
      </Routes>
    </>
  );
}

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <LoadingSpinner message="로딩 중..." />;
  }
  
  return isAuthenticated ? (
    <>
      <TokenErrorBanner />
      {children}
    </>
  ) : (
    <Navigate to="/login" />
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* 따로 띄우는 직원 메모 창: 상단 메뉴 없이 메모만 보인다 */}
            <Route path="/memo-window" element={<PrivateRoute><MemoWindow /></PrivateRoute>} />
            <Route 
              path="/*" 
              element={
                <PrivateRoute>
                  <AppContent />
                </PrivateRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

